import { Link } from "react-router-dom";

function SectionHeader({ title, link, linkText = "View" }) {
  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>{title}</h2>

      {link && (
        <Link to={link} style={linkStyle}>
          {linkText}
        </Link>
      )}
    </div>
  );
}

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "14px",
};

const titleStyle = {
  margin: 0,
  fontSize: "20px",
  fontWeight: "700",
};

const linkStyle = {
  color: "#e10600",
  textDecoration: "none",
  fontWeight: "700",
  fontSize: "14px",
};

export default SectionHeader;